// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"3a7cbedf","186":"1ed51585","256":"c6a9cccb","453":"2844cdb2","726":"d1bce759","830":"96441350","941":"6518cc9e"}[chunkId] + ".chunk.js";
};